import classNames from 'classnames';
import { Button } from '~/components';
import { WizardFooterConfig } from './types';

/**
 * Shared wizard action bar.
 *
 * `sticky` defaults to true because every wizard that mounts this today lives
 * inside a FormDialog/ModalDialog, which owns its own scroll container. See the
 * prop's note in ./types.ts for when a caller must pass `false`.
 */
export const WizardFooter = (props: WizardFooterConfig) => {
  const { primaryButton, secondaryButton, backButton, showDivider = true, sticky = true } = props;
  return (
    <div
      className={classNames(
        'grid w-full grid-cols-2 gap-3 bg-white pt-4 pb-2 sm:flex sm:flex-row sm:gap-4',
        sticky && 'sticky bottom-0 z-0',
        showDivider && 'border-t border-grey-800'
      )}
    >
      {backButton && (
        <Button
          wrap
          className={classNames(
            'w-full max-sm:min-w-0 sm:w-auto',
            !secondaryButton && 'col-span-2'
          )}
          colorVariant="tertiary"
          type={backButton.isSubmit ? 'submit' : 'button'}
          cyTag={backButton.cyTag}
          disabled={backButton.disabled}
          label={backButton.label}
          onClick={backButton.onClick}
        />
      )}
      <div className="contents sm:ml-auto sm:flex sm:w-auto sm:flex-row sm:gap-4">
        {secondaryButton && (
          <Button
            wrap
            className={classNames('w-full max-sm:min-w-0 sm:w-auto', !backButton && 'col-span-2')}
            colorVariant="secondary"
            type={secondaryButton.isSubmit ? 'submit' : 'button'}
            cyTag={secondaryButton.cyTag}
            disabled={secondaryButton.disabled}
            label={secondaryButton.label}
            onClick={secondaryButton.onClick}
          />
        )}
        <Button
          wrap
          className="col-span-2 w-full max-sm:min-w-0 sm:w-auto"
          type={primaryButton.isSubmit ? 'submit' : 'button'}
          cyTag={primaryButton.cyTag}
          disabled={primaryButton.disabled}
          label={primaryButton.label}
          onClick={primaryButton.onClick}
        />
      </div>
    </div>
  );
};
